<template>
   <div class="sd_footer">
       <div class="max_width">
        <h1 class="max_width_111">International Society For Action Learning</h1>
         <h2 class="max_width_222">E-mail：isfalcontact@gmail.com</h2>
       </div>
   </div>
</template>


<script>
   export default {
      data() {
         return {
            footer_link:[
               {
                  id:1,
                  name:"支持服务",
                  list:[
                     {
                        id:1,
                        name:"学习指南",
                        code:"iMveMb"
                     },
                     {
                        id:2,
                        name:"操作指南",
                        code:"JzInIf"
                     },
                     {
                        id:3,
                        name:"常见问题",
                        code:"iUrABr"
                     },
                     // {
                     //    id:4,
                     //    name:"资料下载",
                     //    code:"auuIZ3"
                     // },
                  ]
               },
               {
                  id:2,
                  name:"关于我们",
                 
                  code:"3YRVFr",
                  list:[
                     {
                        id:5,
                        name:"学院介绍",
                        code:"AZNJB3",
                     },
                     {
                        id:6,
                        name:"联系方式",
                        code:"Z7VrYf",
                     },
                  ]
               },
               {
                  id:3,
                  name:"隐私条款",
                  code:"VVvQf2",
                  list:[
                     {
                        id:7,
                        name:"隐私声明",
                        code:"F3yEJb",
                     },
                     {
                        id:8,
                        name:"资源使用版权通告",
                        code:"vqeMvy",
                     },
                  ]
               },
               {
                  id:4,
                  name:"关注我们",
                   code:"zUrABj",
                  list:[
                     {
                        id:9,
                        name:"官网微信",
                        code:"yInyMz",
                     },
                     {
                        id:10,
                        name:"联络官网QQ群",
                        code:"mmQzE3",
                     },
                  ]
               }
            ],
         };
      },
      mounted() {
         // this.initpage();
      },
      methods: {
         // goPath(i){
         //    let _this = this;
         //    if(_this.$route.path == _this.footer_link[i].path){
         //       return false;
         //    }
         //    if(_this.footer_link[i].type == 1){
         //       _this.$router.push(_this.footer_link[i].path);
         //    }else if(_this.footer_link[i].type == 2){
         //       window.location.href = _this.footer_link[i].path;
         //    }
         // },
         // initpage(){
         //    var _this = this;
         //    _this.$api.artList({
         //       categoryCode:'bottom'
         //    }).then(res => {
         //       if (res.code == 200){
         //          _this.footer_link = res.data.list;
         //       }else{
         //          _this.$message.error(res.msg);
         //       }
         //    }).catch(function (error) {
         //       _this.$message.error(error.msg);
         //    });
         // },
      }
   }
</script>
<style lang="less" scoped>

   .sd_footer{
      width: 100%;
      height: 200px;
      background-color: #282828;
      // padding-left: 50px;
      padding-top: 30px;
      .max_width{
         width: 1200px;
         height: 100%;
         margin: auto;
         .max_width_111{
            font-size: 36px;
            font-weight: bold;
            color: rgb(31, 135, 232);
         }
         .max_width_222{
            margin-top: 20px;
            font-size: 24px;
            color: #666666;
         }
         
         .max_width_a{
            display: flex;
            width: 100%;
            // background-color: #ED8A08;
            height: 240px;
            padding-left: 80px;
            .max_width_t:not(:last-child)   {
              
            // margin-right: 300px;
            // margin-left: 150px;
               margin-right: 230px;
               // background-color: #ED8A08;

         }
         .max_width_t_1{
               color: #ED8A08;
               margin-bottom: 20px;
               font-size: 16px;
               cursor: pointer;
               .max_width_t_1_1{
                  color: #ED8A08;
               font-size: 16px;
               }
               &:hover{
                  .max_width_t_1_1{
                     color: #fa9a1d;
                  }
               }
            }
            .max_width_t_2{
               color: #C5C5C5;
               font-size: 12px;
               margin-bottom: 5px;
               cursor: pointer;
               .max_width_t_2_1{
                  color: #C5C5C5;
                  font-size: 12px;
               }
               &:hover{
                  .max_width_t_2_1{
                     color: #fff;
                  }
               }
            }
         }
         .max_width_c{
            width: 1050px;
            height: 2px;
            background-color: #696767;
            margin-left: 80px;
            margin-bottom: 20px;
         }
         .max_width_b{
            display: flex;
            color: #C5C5C5;
            // margin-left: 150px;
            margin-left: 80px;
            .max_width_b_1{
               p{
               margin-bottom: 10px;
               }
            }
            .max_width_b_2{
               margin-left: 50px;
               margin-top: 20px;
               display: flex;
               .max_width_b_2_1{
                  margin-right: 10px;
               }
               .max_width_b_2_2{
                  margin-left: 20px;
                  .max_width_b_2_2_1{
                     position: absolute;
                     margin-top: -25px;
                  }
               }
            }
            .max_width_b_3{
               width: 100px;
               height: 100px;
               margin-left: 180px;
               .max_width_b_3_2{
                  font-size: 14px;
                  text-align: center;
               }
            }
         }
        
      }
   }
</style>
